var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgElnkLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ELNK_Logo_-_Default",
    "data-name": "ELNK Logo - Default",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.511,
    height: 25,
    viewBox: "0 0 27.511 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M3.195,14.619A9.516,9.516,0,0,1,16.077,3.659c.905-.6,1.909-1.229,2.931-1.8A12.462,12.462,0,0,0,.939,17.209c.673-.834,1.429-1.7,2.256-2.589",
    transform: "translate(1.299)",
    fill: "#f68c1e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M18.8,0l-.046.024c-.524.274-1.094.6-1.7.96-.315.19-.642.393-.975.606A9.516,9.516,0,1,1,2.014,13.584Q1.019,14.707,0,15.994A12.462,12.462,0,1,0,18.8,0",
    transform: "translate(3.245 3.156)",
    fill: "#f68c1e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M4.449,3.223c.6-.363,1.172-.686,1.7-.96A9.806,9.806,0,0,1,10.021.9a.812.812,0,0,1,.623.187c.263.306.159,1.564-1.88,4.34q.247.438.46.9c2.2-2.88,2.92-4.881,2.105-5.827A1.637,1.637,0,0,0,10.021,0C8.144,0,4.355,1.949,0,5.108a2.964,2.964,0,0,1,.532.733c1.339-.972,2.708-1.89,3.917-2.618",
    transform: "translate(15.857 0.916)",
    fill: "#4d5055"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M6.22,16.087a11.468,11.468,0,0,1-4.606,1.734.756.756,0,0,1-.6-.215c-.3-.353.015-1.932,2.162-4.665a59.751,59.751,0,0,1,8.385-8.629c.132-.114.715-.6,1.186-1a1.814,1.814,0,1,0-.8-1.5,1.794,1.794,0,0,0,.205.821c-.442.368-.97.811-1.1.922a61.712,61.712,0,0,0-8.6,8.837C.209,15.351-.487,17.25.33,18.2a1.586,1.586,0,0,0,1.285.508,12.9,12.9,0,0,0,5.4-2.032l.024-.014q-.42-.27-.817-.572",
    transform: "translate(0 6.296)",
    fill: "#4d5055"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElnkLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/elnk-logo.37dae4bbcc47afbe09160fafeb455471.svg";